import React from 'react'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { useTranslation } from 'react-i18next'

export const PublishListing = ({ formik, nextStep, publishDraft, publishLive, loader }) => {
    const { t } = useTranslation()

    return (
        <>
            <h2 className="text-left light-white mb-3">{t('publish_your_listing')}!</h2>

            <div className="publishContents">
                <div className="titles">
                    <p>{t('car_info')}</p>
                </div>
                <ul>
                    <li>
                        <p>{t('summer_tyres')}:</p>
                        <p className="ans">
                            {formik.values.tyres == 'Summer tyres' ? 'Yes' : 'No'}
                        </p>
                    </li>
                    <li>
                        <p>{t('winter_tyres')}:</p>
                        <p className="ans">
                            {formik.values.tyres == 'Summer tyres' ? 'No' : 'Yes'}
                        </p>
                    </li>
                    <li>
                        <p>{t('keys')}:</p>
                        <p className="ans">{formik.values.keys}</p>
                    </li>
                    <li>
                        <p>{t('last_service_occasion')}:</p>
                        <p className="ans">
                            {formik.values.month} {formik.values.year}
                        </p>
                    </li>
                    <li>
                        <p>{t('is_the_car_paid_off')}?</p>
                        <p className="ans">
                            {formik.values.paidOff ? formik.values.paidOff : 'No'}
                        </p>
                    </li>
                </ul>
                <div className="titles mb-3">
                    <p>{t('expected_price')}:</p>
                    <p>{formik.values.price} SEK</p>
                </div>
                {/* <PrimaryButton
                    customClassName="login-confirm-btn"
                    label="Publish Draft"
                    iconRight={<span className="material-icons">arrow_right_alt</span>}
                    type="button"
                    onClick={publishDraft}
                /> */}
                <PrimaryButton
                    customClassName="login-confirm-btn mt-4"
                    label={loader ? `${t('please_wait')}...` : t('send_for_admin_approval')}
                    iconRight={<span className="material-icons">arrow_right_alt</span>}
                    type="button"
                    onClick={publishLive}
                    disabled={loader}
                />
            </div>
        </>
    )
}
